﻿import { Game, LiveData } from '../apiTypes/GameService';
import { useQueries, UseQueryResult } from '@tanstack/react-query';
import { getLiveData } from '../api/CasinoApi';
import { useCallback, useMemo } from 'react';

const useLiveData = (games: Game[]) => {

  const gameIdsSortedByUpdateFrequency: Record<string, string[]> = useMemo(() => {
    return games.reduce((accumulator: Record<string, string[]>, currentValue) => {
      if (!currentValue.id) return accumulator;

      let key: string;
      if (typeof currentValue.updateFrequency === 'number') {
        key = currentValue.updateFrequency.toString(10);
      } else {
        return accumulator;
      }

      if (key in accumulator) accumulator[key].push(currentValue.id);
      else accumulator[key] = [currentValue.id];

      return accumulator;
    }, {});
  }, [games]);

  const combine = useCallback((results: UseQueryResult<LiveData[], Error>[]) => {
    return {
      data: results.map((result) => result.data).filter(Boolean).flat(),
      pending: results.some((result) => result.isPending),
    };
  }, []);

  const gameQueries = useQueries({
    queries: Object.keys(gameIdsSortedByUpdateFrequency).length ? Object.entries(gameIdsSortedByUpdateFrequency).map(([updateFrequency, ids]) => {
      return {
        queryKey: ['livedata', ...ids],
        queryFn: () => getLiveData(ids),
        refetchInterval: Number(updateFrequency ?? 0) * 1000
      };
    }) : [],
    combine
  });

  return gameQueries.data;
};

export default useLiveData;
